export const randomStr = () => Math.random().toString(36).substring(2);
